<app-form-master
  [form]="form"
  class="add-document-items"
  (rawFormChanges)="onUpdateDocumentItem($event)"
  (submitForm)="onSaveDocumentItem()"
>
  <div *ngIf="documentSettings?.showProductCode" class="form-row">
    <app-input-field
      class="product-code"
      [label]="'LABEL.ITEM_CODE' | translate"
      [condensed]="true"
      [fieldControl]="form.get(formKeys.CODE)"
      [focusableTrigger$]="productCodeFocusableTrigger$"
      [options]="autoCompleteOptions[formKeys.CODE]"
      [rightIcon]="fetchingResults[formKeys.CODE] ? loadingSpinnerIcon : null"
      fieldId="code_field"
      (onAutoCompleteFetchStart)="onAutoCompleteFetchStart(formKeys.CODE)"
      (onAutoCompleteFetchEnd)="onAutoCompleteFetchEnd($event)"
      (onAutoCompleteDestroy)="clearSearchLoadingSpinner()"
      (onAutoCompleteSet)="
        onAutoCompleteSet(
          $event,
          companySettings?.productNameEnabled
            ? nameFocusableTrigger
            : descriptionFocusableTrigger
        )
      "
    >
    </app-input-field>
  </div>

  <div *ngIf="companySettings?.productNameEnabled" class="form-row">
    <app-input-field
      class="item-name"
      [label]="'LABEL.ITEM_NAME' | translate"
      [condensed]="true"
      [placeholder]="'LABEL.ITEM_NAME' | translate"
      [fieldControl]="form.get(formKeys.NAME)"
      [focusableTrigger$]="nameFocusableTrigger$"
      [options]="autoCompleteOptions[formKeys.NAME]"
      [rightIcon]="fetchingResults[formKeys.NAME] ? loadingSpinnerIcon : null"
      [errorMessages]="itemNameErrorMessage"
      fieldId="item_name_field"
      e2eId="document-items-name-field"
      (onAutoCompleteFetchStart)="onAutoCompleteFetchStart(formKeys.NAME)"
      (onAutoCompleteFetchEnd)="onAutoCompleteFetchEnd($event)"
      (onAutoCompleteDestroy)="clearSearchLoadingSpinner()"
      (onAutoCompleteSet)="
        onAutoCompleteSet($event, descriptionFocusableTrigger)
      "
    >
    </app-input-field>
  </div>

  <div class="form-row">
    <app-textarea-field
      class="description"
      [label]="'LABEL.ITEM_DESCRIPTION' | translate"
      fieldId="description_field"
      textareaE2eId="document-items-description-field"
      [condensed]="true"
      [fieldControl]="form.get(formKeys.DESCRIPTION)"
      [options]="
        companySettings?.productNameEnabled
          ? null
          : autoCompleteOptions[formKeys.DESCRIPTION]
      "
      [maxlength]="descriptionMaxlength"
      [focusableTrigger$]="descriptionFocusableTrigger$"
      [rightIcon]="
        companySettings?.productNameEnabled
          ? null
          : fetchingResults[formKeys.DESCRIPTION] && loadingSpinnerIcon
      "
      (onAutoCompleteSet)="onAutoCompleteSet($event)"
      (onAutoCompleteFetchStart)="
        onAutoCompleteFetchStart(formKeys.DESCRIPTION)
      "
      (onAutoCompleteFetchEnd)="onAutoCompleteFetchEnd($event)"
      (onAutoCompleteDestroy)="clearSearchLoadingSpinner()"
    >
    </app-textarea-field>
  </div>

  <div class="form-row">
    <div class="left-contents">
      <app-number-field
        *ngIf="documentSettings?.showQuantityAndRate"
        class="quantity-field"
        [label]="'LABEL.QUANTITY' | translate"
        fieldId="quantity_field"
        e2eId="document-items-quantity-field"
        [locale]="documentSettings?.locale"
        [decimalDigits]="4"
        [formControl]="form.get(formKeys.QTY)"
      >
      </app-number-field>

      <app-currency-field
        class="rate-field"
        [label]="
          (documentSettings?.showQuantityAndRate ? 'LABEL.RATE' : 'LABEL.PRICE')
            | translate
        "
        fieldId="rate_field"
        e2eId="document-items-rate-field"
        [formControl]="form.get(formKeys.UNIT_PRICE)"
        [currencyCode]="documentSettings?.currencyCode"
        [locale]="documentSettings?.locale"
        [condensed]="true"
      >
      </app-currency-field>
    </div>

    <div class="right-contents item-amount">
      {{
        itemTotal
          | money: documentSettings?.currencyCode:documentSettings?.locale
      }}
    </div>
  </div>

  <div class="form-row">
    <div class="left-contents">
      <app-document-item-options
        class="document-item-options"
        [taxes]="documentTaxes"
        [withholdingTax]="documentWithholdingTax"
        [currencyCode]="documentSettings?.currencyCode"
        [locale]="documentSettings?.locale"
        [documentItem]="item"
        [showDiscount]="enableDiscount"
        [trackingObject]="trackingObject"
        [trackingScreenName]="trackingScreenName"
        [showMarkup]="documentItem?.isExpenseReference()"
        [documentSettings]="documentSettings"
        (onUpdateDocumentItemOptions)="onUpdateDocumentItemOptions($event)"
      >
      </app-document-item-options>
    </div>

    <div class="right-contents item-actions">
      <button
        *ngIf="documentItem"
        type="button"
        class="action delete-action"
        trackable
        [trackingObject]="trackingObject"
        [trackingAction]="itemDeleteAction"
        [trackingAdditionalProperties]="trackingAdditionalProperties"
        (click)="deleteDocumentItem.emit(item)"
      >
        {{ 'ACTION.DELETE' | translate }}
      </button>

      <button
        type="button"
        class="action secondary-action"
        trackable
        [trackingObject]="trackingObject"
        [trackingAction]="itemCancelAction"
        [trackingAdditionalProperties]="trackingAdditionalProperties"
        (click)="close.emit()"
      >
        {{ 'ACTION.CANCEL' | translate }}
      </button>

      <button
        type="submit"
        class="action primary-action"
        data-e2e-id="document-items-save-action"
        trackable
        [trackingObject]="trackingObject"
        [trackingAction]="itemSaveAction"
        [trackingAdditionalProperties]="trackingAdditionalProperties"
        (click)="checkFormValidity()"
      >
        {{ primaryButtonTextKey | translate }}
      </button>
    </div>
  </div>
</app-form-master>
